import React from 'react';

import { mdiChevronDown } from '@mdi/js';
import Icon from '@mdi/react';

import { Box, Divider, Typography, Paper, Grid } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { Alert, Link, Button } from 'daaas-ui';

import { useTranslation } from 'react-i18next';

import AxiosStatic from 'axios';
import { useAxios } from '../Provider/AxiosProvider';

import { config } from '../../Config/AppConfig';

import VmTableVdl from './VmTableVdl';
import { SupportDialog } from './Dialogs';

const Root = styled('div')(({ theme }) => ({
  '& .vmSection__tableHeading': {
    fontWeight: 700,
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(2),
    },
  },
}));

export default function VmSectionVdl() {
  const { t } = useTranslation(['common', 'vmvdl']);

  const [vdlRows, setVdlRows] = React.useState(null);

  const [isLoadingVdl, setIsLoadingVdl] = React.useState(true);

  const [hasRowsVdl, setHasRowsVdl] = React.useState(false);

  const [vmError, setVmError] = React.useState(false);

  const [open, setOpen] = React.useState({
    supportDialog: false,
  });

  const toggleDialog = (element, value) => {
    setOpen({ ...open, [element]: value });
  };

  const axios = useAxios(true);

  const getVmList = (dtl) => {
    axios
      .get(config.api.API_VM_LIST, { params: { dtl, inclShutdown: 'true' } })
      .then((result) => {
        setVmError(false);
        const newRows = JSON.parse(
          JSON.stringify(Object.values(result.data.vmList))
        );

        setVdlRows(newRows);
        setHasRowsVdl(newRows.length > 0);
        setIsLoadingVdl(false);
      })
      .catch((error) => {
        setVmError(true);
        // eslint-disable-next-line no-console
        console.log(`error is: ${error}`);
        setIsLoadingVdl(false);
        // If we have a cancellation error, it is due to missing authorization header.
        if (AxiosStatic.isCancel(error)) {
          // eslint-disable-next-line no-console
          console.log('AxiosStatic.isCancel');
        }
      });
  };

  React.useEffect(() => {
    // Call the APIs to populate the table
    getVmList('vDL');
  }, []);

  return (
    <Root>
      <Typography
        component="h2"
        variant="h3"
        sx={{
          ml: 1,
          mt: 3,
          mb: 3,
        }}
      >
        {t('vmvdl:myVMs')}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Box>
        {isLoadingVdl ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {hasRowsVdl ? (
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<Icon path={mdiChevronDown} size={1} />}
                  aria-controls="vdl-vms-content"
                  id="vdl-vms-header"
                >
                  <Typography
                    component="h3"
                    variant="body1"
                    className="vmSection__tableHeading"
                  >
                    {t('vmvdl:VDLVMs')}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <VmTableVdl dtl="vDL" rows={vdlRows} />
                </AccordionDetails>
              </Accordion>
            ) : (
              // eslint-disable-next-line react/jsx-no-useless-fragment
              <>
                {vmError ? (
                  <Alert open severity="warning" closeable={false}>
                    {t('vmvdl:VmLoadError1')}
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <Link
                      component="button"
                      onClick={() =>
                        toggleDialog('supportDialog', !open.supportDialog)
                      }
                    >
                      {t('vmvdl:VmLoadErrorLink')}
                    </Link>
                    {t('vmvdl:VmLoadError2')}
                  </Alert>
                ) : (
                  <Paper className="das-paper" sx={{ p: 2 }}>
                    <Grid container justifyContent="center">
                      <Grid item xs={12} lg={8} sx={{ textAlign: 'center' }}>
                        <Typography sx={{ mb: 3 }}>
                          {t('vmvdl:noVms')}
                        </Typography>
                        <Typography>{t('vmvdl:noVmsP1')}</Typography>
                        <Typography>{t('vmvdl:noVmsP2')}</Typography>
                        <Button
                          sx={{ mt: 3 }}
                          variant="contained"
                          color="primary"
                          href={t('common:hrefMsFormsGetStarted')}
                          target="_blank"
                        >
                          {t('common:startaProject')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                )}
              </>
            )}
            <SupportDialog
              open={open.supportDialog}
              toggleDialog={() =>
                toggleDialog('supportDialog', !open.supportDialog)
              }
            />
          </>
        )}
      </Box>
    </Root>
  );
}
